import { TipoIstanzaFascicoloVO } from "./tipo-istanza-fascicoloVO";

export class ValoreCampoVO {
  valore: string;
  valorePipe: string;
}
